import Pagination from "./Pagination";
import "./Pagination.scss";

export const getPageCount = (list: Array<any>, itemsPerPage: number) => Math.ceil(list.length / itemsPerPage)

export const paginateFn = <T>(list: Array<T>, itemsPerPage: number) => {
  const pageCount = getPageCount(list, itemsPerPage);

  return Array.from({ length: pageCount }, (_, pageIndex) => {
    const startIndex = pageIndex * itemsPerPage;
    return list.slice(startIndex, startIndex + itemsPerPage);
  });
}

export default Pagination